import React from "react"
// MUI
import {Button, Grid} from "@mui/material"
import FileCopyIcon from "@mui/icons-material/FileCopy"
import MapIcon from "@mui/icons-material/Map"
// style
import {style} from "./style"


export default function QRCodeLocation(props: any) {
    let _href = `https://maps.google.com/?q=${props.fieldDisplay.lat},${props.fieldDisplay.lon}`;

    if (props.isParsedMobile) {
        _href = `geo:${props.fieldDisplay.lat},${props.fieldDisplay.lon}`;
    }

    let lon: string = '';
    let lat: string = '';

    if (!!props.fieldDisplay.lat && !!props.fieldDisplay.lon) {
        lon = props.fieldDisplay.lon;
        lat = props.fieldDisplay.lat;
    }

    return (
        <Grid item xs={12}>
            <iframe title="QR Code location" width="100%" height="180"
                    style={style.iframe} loading="lazy"
                    allowFullScreen
                    src={"https://www.google.com/maps/embed/v1/place?q=" + lat + "%2C%20" + lon + "&key=AIzaSyCm29uxTxLUrXEW_ahS8G8GoNukrLVhNg8"}/>
            <Grid container justifyContent={'center'} spacing={2} justifyItems={'center'}>
                <Grid item>
                    <Button
                        variant={'contained'}
                        sx={style.button}
                        onClick={() => props.copyContentToClipBoard(`${lon},${lat}`)}
                    >
                        <FileCopyIcon sx={style.icon}/> Copy LON,LAT
                    </Button>
                </Grid>

                <Grid item>
                    <Button
                        variant={'contained'}
                        sx={style.button2}
                        href={_href}
                        target={'_blank'}
                    >
                        <MapIcon style={style.icon}/> App
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
